import {
  getPosthogIfReady,
  initPosthogDeferred,
  restorePosthogConversationsConfig,
} from "config/posthog-runtime";
import type {
  PostHogConversationsApi,
  PostHogWithConversations,
} from "types/posthog-conversations";

import { logPosthogSupportDiagnostics } from "./posthogSupportDiagnostics";

const DEFAULT_MAX_WAIT_MS = 15_000;
const DEFAULT_POLL_INTERVAL_MS = 200;

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const waitForPosthogConversations = async (
  maxWaitMs = DEFAULT_MAX_WAIT_MS,
  pollIntervalMs = DEFAULT_POLL_INTERVAL_MS
): Promise<PostHogConversationsApi | null> => {
  const deadline = Date.now() + maxWaitMs;

  // After a logout the SDK no longer knows Support is on (RV-1067); one attempt per check,
  // never past this check's own deadline.
  await Promise.race([restorePosthogConversationsConfig(), sleep(maxWaitMs)]);

  while (Date.now() < deadline) {
    const posthog =
      (getPosthogIfReady() as PostHogWithConversations | null) ??
      ((await initPosthogDeferred()) as PostHogWithConversations | null);
    const conversations = posthog?.conversations ?? null;

    if (conversations?.isAvailable()) {
      return conversations;
    }

    await sleep(pollIntervalMs);
  }

  if (process.env.NODE_ENV === "development") {
    await logPosthogSupportDiagnostics();
  }

  return null;
};
